import { ReactComponent as Tennis } from "../../static/images/tennis.svg";
import { ReactComponent as Boxing } from "../../static/images/boxing.svg";
import { ReactComponent as PersonalTrainer } from "../../static/images/presonal_trainer.svg";
import { ReactComponent as Yoga } from "../../static/images/yoga.svg";
import { ReactComponent as Soccer } from "../../static/images/soccer.svg";
import { ReactComponent as Basketball } from "../../static/images/basketball.svg";
import { ReactComponent as BallroomDacne } from "../../static/images/dance.svg";
import { ReactComponent as Padel } from "../../static/images/padel.svg";
import { ReactComponent as Pickleball } from "../../static/images/pickleball.svg";
import { ReactComponent as AmericanFootball } from "../../static/images/american_ball.svg";
import { ReactComponent as Judo } from "../../static/images/judo.svg";
import { ReactComponent as Golf } from "../../static/images/golf.svg";
import { ReactComponent as Baseball } from "../../static/images/baseball.svg";
import { ReactComponent as Karate } from "../../static/images/karate.svg";
import { ReactComponent as MMA } from "../../static/images/mma.svg";
import { ReactComponent as Ballet } from "../../static/images/ballet.svg";
import { ReactComponent as HipHop } from "../../static/images/hip_hop.svg";
import { ReactComponent as Gymnastics } from "../../static/images/gymnastics.svg";
import { ReactComponent as Fitness } from "../../static/images/fitness.svg";

import { ReactComponent as Math } from "../../static/images/math.svg";
import { ReactComponent as EnglishLanguage } from "../../static/images/english_lesson.svg";
import { ReactComponent as Biology } from "../../static/images/biology.svg";
import { ReactComponent as Chemistry } from "../../static/images/chemistry.svg";
import { ReactComponent as Physics } from "../../static/images/phisics.svg";
import { ReactComponent as History } from "../../static/images/history.svg";
import { ReactComponent as Geography } from "../../static/images/geography.svg";
import { ReactComponent as ComputerScienceCoding } from "../../static/images/coding.svg";
import { ReactComponent as ForeignLanguages } from "../../static/images/foreign_language.svg";
import { ReactComponent as Literature } from "../../static/images/literature.svg";
import { ReactComponent as Physychology } from "../../static/images/psychology.svg";

const iconMap = {
  Tennis,
  Boxing,
  PersonalTrainer,
  Yoga,
  Soccer,
  Basketball,
  BallroomDacne,
  Padel,
  Pickleball,
  AmericanFootball,
  Judo,
  Golf,
  Baseball,
  Karate,
  MMA,
  Ballet,
  HipHop,
  Gymnastics,
  Fitness,
  Math,
  EnglishLanguage,
  Biology,
  Chemistry,
  Physics,
  History,
  Geography,
  ComputerScienceCoding,
  ForeignLanguages,
  Literature,
  Physychology,
};

export const removeExtraChars = (string) => {
  return string.replace(/[^a-zA-Z]/g, "");
};

export const renderIcon = (category) => {
  const normalized = removeExtraChars(category);

  return iconMap[normalized];
};
